import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const AnalyticsContext = createContext();

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  if (!context) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }
  return context;
};

export const AnalyticsProvider = ({ children }) => {
  const { token } = useAuth();
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadAnalyticsData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      // Dashboard admin (stats globales)
      const { data } = await axios.get('/api/analytics/dashboard');
      setAnalytics(data.analytics ? {
        overview: {
          totalStudents:       data.analytics.totalUsers        || 0,
          totalCourses:        data.analytics.publishedCourses  || 0,
          totalEnrollments:    data.analytics.totalEnrollments  || 0,
        },
        topCourses: data.topCourses || [],
      } : null);
    } catch (err) {
      // Si l'utilisateur n'est pas admin, on ignore silencieusement
      if (err.response?.status !== 403) {
        setError(err.response?.data?.error || err.message);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { if (token) loadAnalyticsData(); }, [token, loadAnalyticsData]);

  const value = {
    analytics,
    loading,
    error,
    refresh: loadAnalyticsData,
  };

  return (
    <AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>
  );
};
